var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group',_vm._l((7),function(i){return _c('b-list-group-item',{key:i},[_c('b-skeleton',{attrs:{"width":"100%"}}),_c('b-skeleton',{staticClass:"float-right",attrs:{"width":"15%"}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }